require('../widgets/cookie.coffee')

class window.AgePopup
  constructor: ->
    @cookieObject = new window.Cookie()
    @initButtons()

  initButtons: ->
    self = this

    $('.i-am-eighteen').click ->
      $('.age-popup').addClass('age-popup--closed');
      self.cookieObject.setCookie('kvz_age_confirm', true, {expires: 31536000000})
      $('body').removeClass('body-overflow')

    $('.i-am-not-eighteen').click ->
      $('.age-popup__content').html('<h1>Мы не можем предоставить вам доступ на сайт. Приносим свои извинения.</h1>');



// WEBPACK FOOTER //
// ./assets/javascripts/app/age_popup.coffee